__turbopack_context__.v({
  "root": "pUBf5a_root",
  "trampolineImage": "pUBf5a_trampolineImage",
});
